"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function calculate(code, args = null) {
    try {
        // eslint-disable-next-line no-new-func
        return new Function('args', `return ${code}`)(args);
    }
    catch (error) {
        return error;
    }
}
exports.default = calculate;
